import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { NotificationsService } from '@services/notifications.service';

@Component({
  selector: 'app-model-input',
  templateUrl: './model-input.component.html',
  styleUrls: ['./model-input.component.scss'],
  standalone: false,
})
export class ModelInputComponent implements OnInit {
  private _selectedItem;
  @Input()
  set selectedItem(v) {
    this._selectedItem = v;
    if (this.item) this.procesSelected();
  }
  get selectedItem() {
    return this._selectedItem;
  }
  @Input() item;
  @Output() changed = new EventEmitter();
  @Input() parentView: any;
  @Input() rootItem;
  selectedType = 'self';
  selectedKey = '';
  dataKeys = [];
  dataTypes = [];
  dataTypesOptions = [];
  filteredKeys = [];
  error = false;
  constructor(
    private dataModelService: DataModelService,
    private notifications: NotificationsService
  ) {}

  ngOnInit() {
    this.procesSelected();
  }

  procesSelected() {
    if (this.parentView?.mode) {
      console.log(this.selectedItem[this.item.param]);

      let current = this.selectedItem[this.item.param];
      let details;
      if (current) {
        details = current.split(/\./g);
      } else {
        this.selectedType = 'self';
        this.selectedType = null;
      }
      console.log(details);
      if (details) {
        if (details.length > 1) {
          this.selectedType = details[0];
          this.selectedKey = details[1];
        } else {
          this.selectedType = 'self';
          this.selectedKey = details[0];
        }
      }
      this.dataModelService.getTypes().subscribe(types => {
        this.dataTypes = types;
        this.dataTypesOptions = [
          { label: 'Self', value: 'self' },
          { label: 'Institution', value: 'institution' },
          ...types.map(t => ({ label: t.name, value: t.name })),
        ];
      });
      this.updateRelated();
    }
  }

  filter(event?) {
    this.updateKey();
    if (/\s/.test(this.selectedKey)) {
      this.error = true;
      this.filteredKeys = [];
    } else {
      this.error = false;
    }
    this.filteredKeys = this.filterKeys(
      this.dataKeys,
      event?.query || this.selectedKey
    );
  }

  filterKeys(arr, filter) {
    if (filter && filter.length > 0) {
      return arr.filter(item => {
        if (item.friendlyname && item.friendlyname.length > 0)
          return item.friendlyname
            .toLowerCase()
            .startsWith(filter.toLowerCase());
        else return item.name.toLowerCase().startsWith(filter.toLowerCase());
      });
    } else {
      return [];
    }
  }

  addSearchItems(keys) {
    this.dataKeys = [];
    if (keys && keys.length > 0) {
      keys.forEach(key => {
        this.dataKeys.push(key);
      });
    }
    console.log(this.dataKeys);
  }

  updateRelated() {
    let type;
    console.log('ROOT:', this.rootItem);
    console.log('SELECTED:', this.selectedItem);
    console.log('ITEM:', this.item);

    if (this.selectedType === 'institution') {
      this.addSearchItems([
        { name: 'title', friendlyname: 'Title' },
        { name: 'id', friendlyname: 'ID' },
      ]);
    } else {
      if (this.selectedType && this.selectedType != 'self') {
        type = this.selectedType;
      } else {
        if (this.item.data_type) {
          if (this.rootItem) {
            type = this.rootItem[this.item.data_type];
          } else {
            type = this.selectedItem[this.item.data_type];
          }
        } else {
          type = this.parentView.type;
        }
      }
      if (type?.push) {
        type = type[0]?.name;
      }

      this.dataModelService.getKeys(type).subscribe(keys => {
        this.addSearchItems(keys);
      });
      this.updateKey();
    }
  }

  existing(selectedKey) {
    if (selectedKey && selectedKey.length > 0) {
      return this.dataKeys.find(k => k.name === selectedKey) ? true : false;
    }
    return false;
  }
  addNewKey() {
    let type;
    if (this.selectedType && this.selectedType != 'self') {
      type = this.selectedType;
    } else {
      if (this.item.data_type) {
        if (this.rootItem) {
          type = this.rootItem[this.item.data_type];
        } else {
          type = this.selectedItem[this.item.data_type];
        }
      } else {
        type = this.parentView.type;
      }
    }

    this.dataModelService
      .addKey(type, this.selectedKey, { canvas: '', blackboard: '' }, false)
      .subscribe(data => {
        if (data.errorMessage) {
          this.notifications.popNotification(data.errorMessage, 'X');
        } else {
          console.log(data);
          try {
            this.selectedKey = data[0].name;
            this.notifications.popNotification(
              this.selectedKey + ' created',
              'X',
              2
            );
          } catch (e) {}
        }
        this.updateRelated();
      });
  }

  updateKey() {
    let value;
    if (this.selectedType && this.selectedType != 'self') {
      value = this.selectedType + '.' + this.selectedKey;
    } else {
      value = this.selectedKey;
    }
    if (value !== this.selectedItem[this.item.param]) {
      this.selectedItem[this.item.param] = value;
      this.changed.emit('');
    }
  }
  updateKeyInput(event?) {
    if (
      event?.target?.value !== undefined &&
      event?.target?.value !== null &&
      !/\s/.test(event?.target?.value)
    ) {
      this.selectedKey = event.target.value;
      let value;
      if (this.selectedType && this.selectedType != 'self') {
        value = this.selectedType + '.' + this.selectedKey;
      } else {
        value = this.selectedKey;
      }
      if (value !== this.selectedItem[this.item.param]) {
        this.selectedItem[this.item.param] = value;
        this.changed.emit('');
      }
    }
  }
}
